module.exports = __webpack_public_path__ + "img/horizontal_3_1_r_pp1_8003.2f2053a2.png";